import httpRequest from "@/auth/http-client";
import { buildPaginationQuery } from "@/helpers/request-helpers";
import { ICampaignStatistics } from "@/interfaces/campaign-statistics.interface";
import { PaginatedResponse, RequestPagination } from "@/types/requests.types";

class CampaignStatisticsService {
  private baseUrl = "api/v1/campaign";

  async getStatistics(
    campaignId: string,
    pagination: RequestPagination
  ): Promise<PaginatedResponse<ICampaignStatistics>> {
    const paginationQuery = buildPaginationQuery(pagination);

    const response = await httpRequest.get(
      `${this.baseUrl}/${campaignId}/statistics?${paginationQuery}`
    );

    return response;
  }
}

const campaignStatisticsService = new CampaignStatisticsService();
export default campaignStatisticsService;
